import React from 'react';
import { AppBar, Box, Button, IconButton, Toolbar, Typography } from '@mui/material';
import { ArrowBack, DesktopWindows } from '@mui/icons-material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/m': 'DashFlow',
  '/m/vender': 'Vender',
  '/m/cobrar': 'Cobrar',
  '/m/producir': 'Producir lote',
  '/m/stock': 'Stock',
  '/m/hoy': 'Hoy',
  '/m/salida': 'Regalo / pérdida',
  '/m/entregas': 'Entregas',
  '/m/gasto': 'Cargar gasto',
};

/**
 * Modo celular: una sola columna, botones grandes y sin menú lateral. Pensado para
 * operar el día a día parado en el local o en la cocina de producción.
 */
const MobileLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/m' || location.pathname === '/m/';
  const title = TITLES[location.pathname.replace(/\/$/, '')] || 'DashFlow';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: 'primary.main' }}>
        <Toolbar sx={{ minHeight: 60 }}>
          {!isHome && (
            <IconButton edge="start" color="inherit" onClick={() => navigate('/m')} aria-label="Volver" sx={{ mr: 1 }}>
              <ArrowBack />
            </IconButton>
          )}
          <Typography variant="h6" fontWeight={800} sx={{ flex: 1 }}>{title}</Typography>
          {isHome && (
            <Button color="inherit" size="small" startIcon={<DesktopWindows />} onClick={() => {
              try { sessionStorage.setItem('df-desktop', '1'); } catch { /* sin storage */ }
              navigate('/dashboard');
            }}>
              Versión completa
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, pb: 6, maxWidth: 760, mx: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MobileLayout;
